export default function () {
    var elements = document.getElementsByClassName("scroll-to-top");

    for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener("click", function () {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        });
    }
}
